import {
    Landmark,
    User,
    CreditCard,
    Hash,
    Wallet,
    Copy,
} from "lucide-react";

import "./ProviderCards.css";

function BankDetailsCard({ provider }) {

    const bank = provider.bankDetails || {};

    const maskedAccountNumber = bank.accountNumber
        ? `********${bank.accountNumber.slice(-4)}`
        : "-";

    const copyToClipboard = (text) => {

        if (!text) return;

        navigator.clipboard.writeText(text);

    };

    return (

        <div className="provider-card">

            <div className="card-header">

                <h3 className="card-title">

                    Bank Details

                </h3>

            </div>

            <div className="info-list">

                <div className="info-row">

                    <div className="info-label">

                        <User size={18} />

                        <span>Account Holder</span>

                    </div>

                    <span className="info-value">

                        {bank.accountHolder || "-"}

                    </span>

                </div>

                <div className="info-row">

                    <div className="info-label">

                        <Landmark size={18} />

                        <span>Bank Name</span>

                    </div>

                    <span className="info-value">

                        {bank.bankName || "-"}

                    </span>

                </div>

                <div className="info-row">

                    <div className="info-label">

                        <CreditCard size={18} />

                        <span>Account Number</span>

                    </div>

                    <span className="info-value">

                        {maskedAccountNumber}

                    </span>

                </div>

                <div className="info-row">

                    <div className="info-label">

                        <Hash size={18} />

                        <span>IFSC Code</span>

                    </div>

                    <div className="copy-value">

                        <span className="info-value">

                            {bank.ifscCode || "-"}

                        </span>

                        {

                            bank.ifscCode && (

                                <button
                                    className="copy-btn"
                                    onClick={() =>
                                        copyToClipboard(bank.ifscCode)
                                    }
                                >

                                    <Copy size={16} />

                                </button>

                            )

                        }

                    </div>

                </div>

                <div className="info-row">

                    <div className="info-label">

                        <Wallet size={18} />

                        <span>UPI ID</span>

                    </div>

                    <div className="copy-value">

                        <span className="info-value">

                            {bank.upiId || "-"}

                        </span>

                        {

                            bank.upiId && (

                                <button
                                    className="copy-btn"
                                    onClick={() =>
                                        copyToClipboard(bank.upiId)
                                    }
                                >

                                    <Copy size={16} />

                                </button>

                            )

                        }

                    </div>

                </div>

                <div className="info-row">

                    <div className="info-label">

                        <Landmark size={18} />

                        <span>Account Type</span>

                    </div>

                    <span className="info-value">

                        {bank.accountType || "Savings"}

                    </span>

                </div>

            </div>

        </div>

    );

}

export default BankDetailsCard;